<div class="common-lateral-panel"
  [ngClass]="{'common-lateral-panel--expand':taskHistoric.fullScreen,
    'common-lateral-panel--no-content':!historicList.length}">
  <div class="common-section-title__lp-container">
    <div class="common-section-title__lp-title-icon">
      <i class="lf-icon-track common-icon__lg"></i>
      <span class="common-section-title__lp-label-text"
        [afTranslate]="'common.historic'">Histórico</span>
    </div>
  </div>
  <div class="common-lateral-panel__body gap-[8px]"
    [ngClass]="{'common-lateral-panel__body--no-content': !historicList.length}">
    @if (historicList.length) {
      <ul class="common-lateral-panel__list-items">
        @for (historic of historicList | afOrderBy: 'date':true; track $index) {
          <li class="common-lateral-panel__item">
            <div class="common-lateral-panel__item-text w-[100px]"> {{historic.operationType}}</div>
            <div class="common-lateral-panel__item-text common-lateral-panel__item-text--flex">{{historic.user}}</div>
            <div class="common-lateral-panel__item-text w-[80px]">{{historic.date | convertDate: 'without-time'}}</div>
          </li>
        }
      </ul>
    } @else {
      <p class="common-lateral-panel__no-content"
        [afTranslate]="'task-historic.task-no-change'">
        La tarea no ha sufrido cambios
      </p>
    }
  </div>
  @if (historicList.length > 3) {
    <div class="common-lateral-panel__expand-block">
      <div class="common-lateral-panel__expand-total-block">
        <p class="common-lateral-panel__expand-total-text">
          <span [afTranslate]="'common.total'">_Total</span>
          <span class="pr-1">:</span>
          <span>{{historicList?.length}}</span>
        </p>
      </div>
      <button class="common-button__expand-toned"
        (click)="taskHistoric.fullScreen = !taskHistoric.fullScreen">
        <i class=" common-icon__md"
        [ngClass]="taskHistoric.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
        <span class="common-button__expand-label-text"
          [afTranslate]="taskHistoric.fullScreen?'common.collapse':'common.expand'"></span>
      </button>
    </div>
  }
</div>
